import { Controller, useFormContext } from 'react-hook-form'

import { CurrencyCentInput, FF2, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

type WithdrawalsOutProps = {
  index: number
}

export const WithdrawalsOut = ({ index }: WithdrawalsOutProps) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`transactionsInfo.${index as 0}.withdrawalsOut`}
      control={control}
      rules={{ validate: (value) => Validators.required.notEmpty(value) }}
      render={({ field }) => (
        <FF2 required field={field} label="Withdrawals" input={(props) => <CurrencyCentInput {...props} />} />
      )}
    />
  )
}
